import { FETCHING_INVESTOR_DESCRIPTIONS, FETCH_INVESTOR_DESCRIPTIONS } from './investorDescriptionsContainerActions'

const initialState = {
  loading: false,
  investorDescriptions: [],
  isInvalid: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INVESTOR_DESCRIPTIONS:
      return { loading: false, investorDescriptions: action.payload }
    case FETCHING_INVESTOR_DESCRIPTIONS:
      return { loading: true, investorDescriptions: [] }
  }
  return state
}
